export const DEFAULTS = Symbol('DEFAULTS');
export const MERGE = Symbol('MERGE');
export const EXTEND = Symbol('EXTEND');
